import apiClient from './apiClient';
import type { ApiResponse } from '../types/api';

export interface ConsultationImagingOrder {
    id: number;
    consultation_id: number;
    imaging_study_id: number;
    clinical_indication?: string;
    observations?: string;
    priority: 'routine' | 'urgent' | 'stat';
    imaging_study?: {
        id: number;
        name: string;
        code: string;
        requires_contrast?: boolean;
        department?: { id: number; name: string };
    };
    created_at?: string;
}

export interface CreateConsultationImagingOrderRequest {
    consultation_id: number;
    imaging_study_id: number;
    clinical_indication?: string;
    observations?: string;
    priority?: string;
}

interface PaginatedData<T> {
    data: T[];
    pagination?: { current_page: number; last_page: number; total: number };
}

export const consultationImagingOrderService = {
    async getByConsultation(consultationId: number): Promise<ConsultationImagingOrder[]> {
        const response = await apiClient.get<PaginatedData<ConsultationImagingOrder>>(
            `/consultation-imaging-orders?consultation_id=${consultationId}&per_page=50`
        );
        return response.data.data;
    },

    async create(data: CreateConsultationImagingOrderRequest): Promise<ConsultationImagingOrder> {
        const response = await apiClient.post<ApiResponse<ConsultationImagingOrder>>(
            '/consultation-imaging-orders',
            data
        );
        return response.data.data;
    },

    async update(id: number, data: Partial<CreateConsultationImagingOrderRequest>): Promise<ConsultationImagingOrder> {
        const response = await apiClient.put<ApiResponse<ConsultationImagingOrder>>(
            `/consultation-imaging-orders/${id}`,
            data
        );
        return response.data.data;
    },

    async delete(id: number): Promise<void> {
        await apiClient.delete(`/consultation-imaging-orders/${id}`);
    },
};

export default consultationImagingOrderService;
